import { Space, Table } from 'antd';
import React, { useContext } from 'react';
import CreateDrawer from '../../../../components/create';
import { PageContext } from '../../../../lib/context';
import RolesForm from './form';
import Loading from "../../../../components/loader";

export default function RolesPage() {
  const { data, usersData, usersColumns, _submitHandler, loading } =
    useContext(PageContext);

  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Roles</p>
      </div>
      <p className="text-xl font-bold mt-5">Manage Roles</p>
      <div className="flex flex-row">
        <div className="w-4/5 mr-3">
          <div className="py-5">
            <Space>
              <CreateDrawer
                title="Create Role"
                _submitHandler={_submitHandler}
                width={800}
              >
                <RolesForm />
              </CreateDrawer>
            </Space>
          </div>
          {loading ? (
            <div className="mt-32">
              <Loading show={loading} />
            </div>
          ) : (
            <Table dataSource={usersData} columns={usersColumns} />)
          }
        </div>
      </div>
    </div>
  );
}
